import { render, staticRenderFns } from "./BillingItemsTable.vue?vue&type=template&id=c131ce6e&scoped=true"
import script from "./BillingItemsTable.vue?vue&type=script&lang=js"
export * from "./BillingItemsTable.vue?vue&type=script&lang=js"
import style0 from "./BillingItemsTable.vue?vue&type=style&index=0&id=c131ce6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c131ce6e",
  null
  
)

export default component.exports